/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Your_FilesInputs */

const en_dashboard_your_files = /** @type {(inputs: Dashboard_Your_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your files`)
};

const es_dashboard_your_files = /** @type {(inputs: Dashboard_Your_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus archivos`)
};

/**
* | output |
* | --- |
* | "Your files" |
*
* @param {Dashboard_Your_FilesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dashboard_your_files = /** @type {((inputs?: Dashboard_Your_FilesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Your_FilesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dashboard_your_files(inputs)
	return en_dashboard_your_files(inputs)
});